export const sfdateperiods = [
    {val: 'minutes' , desc: 'minutes' },
    {val: 'hours' , desc: 'hours' },
    {val: 'days' , desc: 'days' },
    {val: 'busdays' , desc: 'business days' },
    {val: 'weeks' , desc: 'weeks' },
    {val: 'months' , desc: 'months' },
    {val: 'years' , desc: 'years' },
];